import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, FileDownIcon, CompassIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const miniBadges = [{
  emoji: '📘',
  label: '6 volumi'
}, {
  emoji: '🗂',
  label: '23 schede di lavoro (WS-01 → WS-23)'
}, {
  emoji: '🧭',
  label: 'Percorso di 10 sedute in 3 fasi'
}, {
  emoji: '🎁',
  label: '5 bonus professionali'
}, {
  emoji: '🇮🇹',
  label: 'Scritto sul quadro italiano (Legge 4/2013)'
}];
const trustItems = [{
  Icon: LockIcon,
  label: 'Pagamento sicuro'
}, {
  Icon: ZapIcon,
  label: 'Download immediato'
}, {
  Icon: ShieldCheckIcon,
  label: 'Garanzia 14 giorni'
}, {
  Icon: FileDownIcon,
  label: '100% digitale (PDF)'
}];
export function Hero() {
  return <header className="w-full bg-cream" data-id="element-126" data-mp="nbopn7u9oy51">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 pt-8 pb-10 sm:pt-10 sm:pb-14 text-center" data-id="element-127" data-mp="3d1imxgffvoql">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sage-tint text-sage border border-sage-soft text-[11px] sm:text-xs font-semibold uppercase tracking-[0.12em]" data-id="element-128" data-mp="382fdzkwc8ydc">
          <CompassIcon className="w-4 h-4 text-terracotta" aria-hidden="true" data-id="element-129" data-mp="3j6oe7qokeyt9" />
          Il Sistema Completo del Coach™ — Il Metodo BUSSOLA™
        </div>

        <h1 className="mt-6 font-serif font-black text-ink text-[32px] leading-[1.12] sm:text-5xl md:text-[56px] tracking-tight" style={{
        fontSize: "28px"
      }} data-id="element-130" data-mp="399jlt944m740">
          Conduci ogni percorso fino all&apos;ultima seduta,{' '}
          <span className="text-sage" data-id="element-131" data-mp="30fy87t3p6vw6">
            come un professionista con dieci anni di pratica.
          </span>
        </h1>

        <p className="mt-3 font-serif italic text-base sm:text-lg text-ink-soft" data-id="element-132" data-mp="2qk3kijkmaamj">
          Anche se stai lavorando con i tuoi primi clienti.
        </p>

        <p className="mt-4 text-ink-soft text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" style={{
        fontSize: "14px"
      }} data-id="element-133" data-mp="2vjga3c2vhvst">
          Il sistema operativo completo in 6 volumi per chi fa coaching in
          Italia — 23 schede di lavoro, script seduta per seduta e documenti che
          il cliente porta a casa.{' '}
          <strong className="text-ink font-semibold" data-id="element-134" data-mp="s3ur9xru3ab5">
            Dal colloquio esplorativo alla seduta di chiusura.
          </strong>
        </p>

        <div className="mt-5 max-w-xs sm:max-w-md mx-auto" data-id="element-135" data-mp="id9vei3jojvx">
          <img src="https://cdn.magicpatterns.com/uploads/vvyy24AXSHjmn9XNPip5Wz/hf_20260908_202022_1e0d3c7f-2598-485e-9fc6-45df4f336c98.png" alt="I sei volumi del Sistema Completo del Coach su desktop, tablet e telefono, con Il Caveau delle Prove di Progresso, il Kit Documenti del Coach e il quaderno La mia mappa del percorso" className="w-full h-auto mix-blend-multiply" width={1024} height={1024} loading="eager" data-id="element-136" data-mp="dd5dqoqwhj44" />
        </div>

        <div className="flex justify-center" data-id="element-137" data-mp="3ltglflt1eim8">
          <CtaButton data-id="element-138" data-mp="3lui6mj3rolho">Voglio Il Sistema Completo</CtaButton>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-139" data-mp="3hqaian1817jz">
          {trustItems.map(({
          Icon,
          label
        }) => <li key={label} className="flex items-center gap-2 text-sm font-medium text-ink-soft" data-id="element-140" data-mp="1xb5qyhfqoxhp">
              <Icon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-141" data-mp="26a98hgz9d4u3" />
              {label}
            </li>)}
        </ul>

        <ul className="mt-10 flex flex-wrap justify-center gap-2" data-id="element-142" data-mp="2b1hjuik5f09w">
          {miniBadges.map(badge => <li key={badge.label} className="inline-flex items-center gap-1.5 rounded-full bg-white border border-cream-dark px-3.5 py-2 text-xs sm:text-sm font-medium text-ink" data-id="element-143" data-mp="2fzaoh75szm82">
              <span aria-hidden="true" data-id="element-144" data-mp="2oye7kb4z01mk">{badge.emoji}</span>
              {badge.label}
            </li>)}
        </ul>
      </div>
    </header>;
}